<ng-template #loading>
  <br/>
  <div class="container">
    <mat-progress-bar class="progress" mode="indeterminate"></mat-progress-bar>
  </div>
</ng-template>

<div *ngIf="activities != null; else loading">

  <div class="container">
    <p>
      <br/>
      <mat-form-field *ngIf="isAdmin || isGeneralProgramDirector; else programGroupLabel">
        <mat-select placeholder="Program Group" [(value)]="selectedProgramGroup" onchange="">
          <mat-option *ngFor="let programGroup of this.getProgramGroups()" [value]="programGroup">
            {{programGroup.displayName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-template #programGroupLabel>
        <h1>{{programGroupDisplayName}} Activities</h1>
      </ng-template>
    </p>
  </div>

  <div class="activity-list" *ngIf="activities != null && activities.length > 0; else noData">
    <span class="mat-body-strong">{{(activities | programGroupFilter: selectedProgramGroup).length}} Activities</span>
    <div class="mat-elevation-z6">
      <table mat-table [dataSource]="activities | programGroupFilter: selectedProgramGroup">

        <ng-container matColumnDef="councilId">
          <th mat-header-cell *matHeaderCellDef>Council</th>
          <td mat-cell *matCellDef="let activity">{{activity.councilId}}</td>
        </ng-container>

        <ng-container matColumnDef="activityType">
          <th mat-header-cell *matHeaderCellDef>Activity</th>
          <td mat-cell *matCellDef="let activity">
            <div *ngIf="activity.activityTitle">{{activity.activityTitle}}</div>
            <span class="activityType">{{getActivityNameById(activity.activityTypeId)}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="activityStatus">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let activity" [ngClass]="{approved: getActivityStatus(activity) === 'approved', rejected: getActivityStatus(activity) === 'rejected', reviewed: getActivityStatus(activity) === 'reviewed'}">
              <mat-icon *ngIf="getActivityStatus(activity) === 'approved'">check_circle_outline</mat-icon>
              <mat-icon *ngIf="getActivityStatus(activity) === 'rejected'">highlight_off</mat-icon>
              <mat-icon *ngIf="getActivityStatus(activity) === 'reviewed'">pending</mat-icon>
              <br />{{getActivityStatus(activity) | titlecase}}
            </td>
          </ng-container>

        <tr class="activityTable-header-row" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="activitySelected(row)" class="activity-row"></tr>
      </table>
    </div>
  </div>

  <ng-template #noData>
    No activities
  </ng-template>
</div>
